import type { Dayjs } from 'dayjs';
import type { FormInputType } from '../../technical/form/Form.types.ts';
import * as yup from 'yup';
import { isNil } from 'lodash/fp';
import { isDayjsDateNotInTheFuture, isValidDayjsDate } from '../../date.utils.ts';
import { isValidDayjsDateRange } from '../../dateRange.utils.ts';
import type { ModelData } from './MarketRegimeForm.tsx';

export type FormOutputFields = {
  since?: Dayjs | null;
  to?: Dayjs | null;
  assets: {
    id: string;
    symbol: string;
  }[];
  models: ModelData[];
  useSingleModelMode: boolean;
};

export type FormInputFields = FormInputType<FormOutputFields>;

export const schema = yup.object({
  models: yup.array(yup.mixed().required()).required().min(1),
  assets: yup.array(yup.mixed().required()).required(),
  useSingleModelMode: yup.boolean().required().default(true),
  since: yup
    .mixed()
    .nullable()
    .test('validDate', 'Date is invalid', isValidDayjsDate)
    .test('validDateNotFuture', 'Date cannot be in the future', isDayjsDateNotInTheFuture),
  to: yup
    .mixed()
    .nullable()
    .test('validDate', 'Date is invalid', isValidDayjsDate)
    .test('validDateNotFuture', 'Date cannot be in the future', isDayjsDateNotInTheFuture)
    .when('since', ([since], schema) => {
      return schema.test('sinceBeforeTo', 'Must be equal or greater than from', (to) => {
        if (isNil(since) || isNil(to)) {
          return true;
        }
        return isValidDayjsDateRange([since, to]);
      });
    }),
});
